import Vue from 'vue'
import Tag from './Tag'
import Icon from './Icon'
import Card from './Card'
import Chart from './Chart'
import Table from './Table'
import Button from './Button'
import Truncate from './Truncate'
import Checkbox from './Checkbox'
import Pagination from './Pagination'
import TableHouse from './TableHouse'
import {
  AlertError,
  AlertErrors,
  AlertSuccess,
} from 'vform'
import VHasError from './VHasError'
import TablePolicy from './TablePolicy'
import {
  BootstrapVueIcons,
  BFormCheckboxGroup,
  BFormCheckbox,
  BFormRadioGroup,
  BFormInvalidFeedback,
  BFormValidFeedback,
  BFormGroup,
  BFormSelect,
  BCarousel,
  BCarouselSlide,
  BModal,
  VBModal,
  BButton,
  BFormRadio,
  BImgLazy,
  BContainer,
  BRow,
  BCol,
  BCard,
  FormPlugin,
  BFormInput,
  BFormTextarea,
  BFormSelectOption,
  BOverlay,
  BCollapse,
  VBToggle,
  BCalendar,
  BFormRow,
  BAlert,
  BCardHeader,
  BCardFooter,
  BCardBody,
  BCardTitle,
  BTab,
  BTabs,
  BButtonGroup,
  BDropdown,
  BDropdownItem,
  BDropdownItemButton,
  BDropdownDivider,
  BDropdownGroup,
  BDropdownHeader,
  BCardGroup,
  BCardText,
  BProgress,
  BProgressBar,
  BIcon,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BInputGroupText,
  BInputGroupAddon,
  BFormDatepicker,
  BFormTimepicker,
  BBreadcrumb,
  BBreadcrumbItem,
  BListGroup,
  BListGroupItem,
  BBadge,
  BLink,
  BAvatar,
  BTooltip,
  BFormFile,
  BTable,
} from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import Filterable from './Filterable'
import ComponentJimp from './Jimp'
import Fullcalendar from './Fullcalendar'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import InvoiceComponent from './InvoiceComponent'
import CheckComponent from './CheckComponent'
import CustomRouterLink from './CustomRouterLink'
import CustomRouter from './CustomRouter'
import { MultiSelect, ModelSelect } from 'vue-search-select'
import VueMultiSelect from 'vue-multiselect'
import Jcrop from './Jcrop'
import RevertAlert from './RevertAlert'
import ShowAlert from './ShowAlert'
import ShowSearch from './ShowSearchEngine'
import FilterableVertical from './FilterableVertical'

// Customer
Vue.component(Tag.name, Tag)
Vue.component(Icon.name, Icon)
Vue.component(Card.name, Card)
Vue.component(Chart.name, Chart)
Vue.component(Table.name, Table)
Vue.component(Button.name, Button)
Vue.component(Truncate.name, Truncate)
Vue.component(Checkbox.name, Checkbox)
Vue.component(VHasError.name, VHasError)
Vue.component(TableHouse.name, TableHouse)
Vue.component(Pagination.name, Pagination)
Vue.component(AlertError.name, AlertError)
Vue.component(AlertErrors.name, AlertErrors)
Vue.component(AlertSuccess.name, AlertSuccess)
Vue.component(ComponentJimp.name, ComponentJimp)
Vue.component(TablePolicy.name, TablePolicy)
Vue.component(Filterable.name, Filterable)
Vue.component(Fullcalendar.name, Fullcalendar)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component(InvoiceComponent.name, InvoiceComponent)
Vue.component(CheckComponent.name, CheckComponent)
Vue.component(CustomRouterLink.name, CustomRouterLink)
Vue.component(CustomRouter.name, CustomRouter)
Vue.component('multi-select', MultiSelect)
Vue.component('model-select', ModelSelect)
Vue.component('multiselect', VueMultiSelect)
Vue.component(Jcrop.name, Jcrop)
Vue.component(RevertAlert.name, RevertAlert)
Vue.component(ShowAlert.name, ShowAlert)
Vue.component(ShowSearch.name, ShowSearch)
Vue.component(FilterableVertical.name, FilterableVertical)

// Bootstrap
Vue.use(BootstrapVueIcons)
Vue.use(FormPlugin)
Vue.component('b-form-group-radio', BFormRadioGroup)
Vue.component('b-form-valid-feedback', BFormValidFeedback)
Vue.component('b-form-invalid-feedback', BFormInvalidFeedback)
Vue.component('b-form-group', BFormGroup)
Vue.component('b-form-select', BFormSelect)
Vue.component('b-form-select-option', BFormSelectOption)
Vue.component('b-carousel', BCarousel)
Vue.component('b-carousel-slide', BCarouselSlide)
Vue.component('b-modal', BModal)
Vue.directive('b-modal', VBModal)
Vue.component('b-button', BButton)
Vue.component('b-form-checkbox-group', BFormCheckboxGroup)
Vue.component('b-form-checkbox', BFormCheckbox)
Vue.component('b-form-radio', BFormRadio)
Vue.component('b-img-lazy', BImgLazy)
Vue.component('b-container', BContainer)
Vue.component('b-row', BRow)
Vue.component('b-col', BCol)
Vue.component('b-card', BCard)
Vue.component('b-form-input', BFormInput)
Vue.component('b-form-textarea', BFormTextarea)
Vue.component('b-overlay', BOverlay)
Vue.component('b-collapse', BCollapse)
Vue.directive('b-toggle', VBToggle)
Vue.component('b-calendar', BCalendar)
Vue.directive('b-form-row', BFormRow)
Vue.component('b-alert', BAlert)
Vue.component('b-card-header', BCardHeader)
Vue.component('b-card-footer', BCardFooter)
Vue.component('b-card-body', BCardBody)
Vue.component('b-card-title', BCardTitle)
Vue.component('b-card-text', BCardText)
Vue.component('b-card-group', BCardGroup)
Vue.component('b-tabs', BTabs)
Vue.component('b-tab', BTab)
Vue.component('b-button-group', BButtonGroup)
Vue.component('b-dropdown', BDropdown)
Vue.component('b-dropdown-item', BDropdownItem)
Vue.component('b-dropdown-item-button', BDropdownItemButton)
Vue.component('b-dropdown-divider', BDropdownDivider)
Vue.component('b-dropdown-group', BDropdownGroup)
Vue.component('b-dropdown-header', BDropdownHeader)
Vue.component('b-progress', BProgress)
Vue.component('b-progress-bar', BProgressBar)
Vue.component('b-icon', BIcon)
Vue.component('b-input-group', BInputGroup)
Vue.component('b-input-group-prepend', BInputGroupPrepend)
Vue.component('b-input-group-append', BInputGroupAppend)
Vue.component('b-input-group-text', BInputGroupText)
Vue.component('b-input-group-addon', BInputGroupAddon)
Vue.component('b-form-datepicker', BFormDatepicker)
Vue.component('b-form-timepicker', BFormTimepicker)
Vue.component('b-breadcrumb', BBreadcrumb)
Vue.component('b-breadcrumb-item', BBreadcrumbItem)
Vue.component('b-list-group', BListGroup)
Vue.component('b-list-group-item', BListGroupItem)
Vue.component('b-badge', BBadge)
Vue.component('b-link', BLink)
Vue.component('b-avatar', BAvatar)
Vue.component('b-tooltip', BTooltip)
Vue.component('b-form-file', BFormFile)
Vue.component('b-table', BTable)
Vue.component('b-form-radio-group', BFormRadioGroup)
